const getFullLanguage = (lang) => {
    let longLanguage = ''
    
    if (lang === 'es') {
        longLanguage = 'Spanish'
    } else if (lang === 'en') {
        longLanguage = 'English'
    } else if (lang === 'pt') {
        longLanguage = 'Portuguese'
    }
    
    return longLanguage
}

export default getFullLanguage;